// extracted by mini-css-extract-plugin
export default {"container":"w1d2qAdbFpkdCmCkOZrx","callToActionTextAndButton":"oLKlmriRq7UwGSabker3","goldenText":"L1mU50G_3_AC6S4fA1VX","blueText":"Qyjyzw2xw7dL1BvodKP0"};